import type { ChangeEventHandler, FocusEvent } from "react";

const TEXT_FIELD_TYPES = new Set(["text", "search", "email", "url", "tel", "password", "textarea"]);

/**
 * Trim when editing finishes so spaces between words and multiline content remain
 * easy to type. Notify controlled fields (including React Hook Form) before blur.
 * Submit handlers must also trim: Enter can submit without blurring the field.
 */
export function trimTextField<T extends HTMLInputElement | HTMLTextAreaElement>(
  event: FocusEvent<T>,
  onChange?: ChangeEventHandler<T>,
  trimWhitespace = event.currentTarget.type !== "password",
): void {
  const field = event.currentTarget;
  if (!trimWhitespace || field.disabled || field.readOnly || !TEXT_FIELD_TYPES.has(field.type)) return;

  const trimmed = field.value.trim();
  if (trimmed === field.value) return;

  field.value = trimmed;
  onChange?.({ ...event, type: "change", target: field, currentTarget: field });
}
